export const getEnterpriseCalendarEventsRoute = '/enterprise/calendar/upcoming-events/';
export const getEnterpriseCalendarEventsInterviewRoute = '/enterprise/calendar/get-block-interviews/';
export const getEnterpriseCalendarBlockRoute = '/enterprise/calendar/get-block-detail/';
export const createCalendarBlockRoute = '/enterprise/calendar/blocks/create/';
export const createCalendarBlockTimeRoute = '/enterprise/calendar/block/slots/';
// export const updateCalendarBlockRoute = '/employer/calendar/blocks/update/';
export const updateCalendarBlockRoute = '/enterprise/calendar/update-block/';
export const deleteCalendarBlockRoute = '/enterprise/calendar/blocks/delete/';
export const deleteInterviewRoute = '/enterprise/calendar/delete/';
export const updateInterviewRoute = '/enterprise/calendar/edit/';
export const getInterviewBlockSignUps = '/employer/calendar/blocks/signups/';
export const deleteEnterpriseInterviewRoute = '/enterprise/calendar/delete/';
